import type { ApplicationState } from './';
import type { OptionalKeys } from '~/Types/helpers';

export enum StoredStateKeys {
	productSearchableDataSource = 'productSearchableDataSource',
}

export type PersistedState = {
	[StoredStateKeys.productSearchableDataSource]: Pick<
		ApplicationState[StoredStateKeys.productSearchableDataSource],
		| 'dataSources'
		| 'groupedDataSources'
		| 'selectedGrouppingType'
		| 'selectedGrouppingType'
		| 'selectedGroupName'
		| 'pricesPresence'
		| 'datasetPresence'
	> & {
		selectedTypes: string[] | null;
	};
};

export type RevivedState = {
	[StoredStateKeys.productSearchableDataSource]: Pick<
		ApplicationState[StoredStateKeys.productSearchableDataSource],
		| 'dataSources'
		| 'groupedDataSources'
		| 'selectedGrouppingType'
		| 'selectedGrouppingType'
		| 'selectedGroupName'
		| 'pricesPresence'
		| 'selectedTypes'
		| 'datasetPresence'
	> | null;
};

export type StateToRevive = OptionalKeys<PersistedState>;

export enum PersistenStateActionTypes {
	load = '@@LOAD_PERSISTENT_STATE@@',
}

export type LoadPersistentStateAction = {
	type: PersistenStateActionTypes.load;
	revivedPersistedState: RevivedState;
};

export const createLoadPersistentStateAction = (revivedPersistedState: RevivedState): LoadPersistentStateAction => {
	return {
		type: PersistenStateActionTypes.load,
		revivedPersistedState,
	};
};

export const createPersistableState = (state: ApplicationState): PersistedState => {
	const { request, groupedRequest, isFetching, ...productSearchableDataSource } = state.productSearchableDataSource;
	return {
		productSearchableDataSource: {
			...productSearchableDataSource,
			selectedTypes: productSearchableDataSource.selectedTypes
				? Array.from(productSearchableDataSource.selectedTypes)
				: null,
		},
	};
};
